
define('text!SageDotCom/Components/Templates/SharePriceTicker.html',[],function () { return '<p class="current-price">#CurrentSharePrice# #OverrideCurrency#</p>\r\n<p class="share-move #SharePriceArrowClass#">\r\n    <span class="sr-only">#SharePriceArrow#</span>\r\n    <span class="price-change">#SharePriceChange#</span>\r\n</p>\r\n';});

